export type RecentActivityResourceConfig = {
  route: string;
  typename?: string;
};

export const RECENT_ACTIVITY_TYPENAMES: Record<string, string> = {
  flags: 'FlagsAdminV1Flag',
  segments: 'FlagsAdminV1Segment',
  metrics: 'MetricsV1Metric',
  measurements: 'MetricsV1Measurement',
  eventDefinitions: 'EventsAdminV1EventDefinition',
  surfaces: 'WorkflowV1Surface',
  projects: 'CollaborationV1Project',
  initiatives: 'WorkflowV1Initiative',
  collections: 'CollectionsV1Collection',
  assignmentTables: 'MetricsV1AssignmentTable',
  factTables: 'MetricsV1FactTable',
  entities: 'MetricsV1Entity',
};

const resourceConfigs = new Map<string, RecentActivityResourceConfig>();

export const registerRecentActivityResources = (
  configs: Record<string, RecentActivityResourceConfig>,
) => {
  for (const [collection, config] of Object.entries(configs)) {
    resourceConfigs.set(collection, config);
  }
};

export const getResourceRoute = (collection: string): string | undefined =>
  resourceConfigs.get(collection)?.route;

export const getResourceTypename = (collection: string): string | undefined =>
  resourceConfigs.get(collection)?.typename;
